import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface Params {
  projectId: string;
  sensorId: number;
  productKey: string;
}

export function useReplaceSensor() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      post({
        url: `/projects/${params.projectId}/sensors/${params.sensorId}/replace`,
        body: params,
      }),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        predicate: ({ queryKey }) => {
          if (!Array.isArray(queryKey) || queryKey[0] !== 'sensors') {
            return false;
          }

          const queryParams = queryKey[1] as { projectId?: string } | undefined;
          return queryParams?.projectId === projectId;
        },
      });
    },
  });

  const replaceSensor = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    replaceSensor,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
